// extracted by mini-css-extract-plugin
var _1 = "QTz_sgGCnFnEUtrbFwQZ";
var _2 = "POpNKT7DVHAsYRky3v3n";
var _3 = "hv7GaaPsfp_KhOk6bI_Y";
var _4 = "xbLKr2cH9WAPabKuCgBT";
var _5 = "CjVUPrwEyVQubcgv5qCC";
export { _1 as "artist", _2 as "collection", _3 as "holder", _4 as "img", _5 as "root" }
